import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecificSteelProfileForm} from '../specific-steel-profile-form';
import {FrameProfile} from '../../steel-profile';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {CintacValidators} from '../../../_shared/cintac-validators';

@Component({
    selector: 'app-frame-profile-form',
    templateUrl: './frame-profile-form.component.html',
    styleUrls: ['../../../project/project-form-components/project-form.css']
})
export class FrameProfileFormComponent implements OnInit, SpecificSteelProfileForm {
    @Input() profile: FrameProfile;
    @Output() specificIsValid = new EventEmitter<boolean>();
    profileData: AbstractControl;

    formErrors = {
        'B': '',
        'H': '',
        'eo': '',
        'es': '',
        'Wy': '',
        'Aef': '',
        'Ix': '',
        'Q': '',
        'Lc': '',
        'Iy': '',
        'A': '',
        'ry': '',
        'Mc': '',
        'Wx': '',
        'rx': '',
    };

    validationMessages = {
        'B': {
            'required': 'Ingresar valor de B.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'H': {
            'required': 'Ingresar valor de H.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'eo': {
            'required': 'Ingresar valor de eo.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'es': {
            'required': 'Ingresar valor de es.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Wy': {
            'required': 'Ingresar valor de Wy.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Aef': {
            'required': 'Ingresar valor de Aef.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Ix': {
            'required': 'Ingresar valor de Ix.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Q': {
            'required': 'Ingresar valor de Q.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Lc': {
            'required': 'Ingresar valor de Lc.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Iy': {
            'required': 'Ingresar valor de Iy.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'A': {
            'required': 'Ingresar valor de A.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'ry': {
            'required': 'Ingresar valor de ry.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Mc': {
            'required': 'Ingresar valor de Mc.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Wx': {
            'required': 'Ingresar valor de Wx.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'rx': {
            'required': 'Ingresar valor de rx.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
    };

    constructor(private fb: FormBuilder) {
        this.profileData = this.fb.group({
            B: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            H: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            eo: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            es: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Wy: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Aef: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Ix: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Q: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Lc: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Iy: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            A: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            ry: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Mc: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Wx: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            rx: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
        });
    }

    ngOnInit() {
        this.profileData.reset({
            B: this.profile.B,
            H: this.profile.H,
            eo: this.profile.eo,
            es: this.profile.es,
            Wy: this.profile.Wy,
            Aef: this.profile.Aef,
            Ix: this.profile.Ix,
            Q: this.profile.Q,
            Lc: this.profile.Lc,
            Iy: this.profile.Iy,
            A: this.profile.A,
            ry: this.profile.ry,
            Mc: this.profile.Mc,
            Wx: this.profile.Wx,
            rx: this.profile.rx,
        });
        this.profileData.valueChanges.subscribe(values => this.onValueChanged());
    }

    private onValueChanged() {
        const form = this.profileData;
        this.updateProfile();
        Object.keys(this.formErrors).forEach(field => {
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        this.formErrors[field] += messages[key] + ' ';
                    }
                }
            }
        });
        this.specificIsValid.emit(this.profileData.valid);
    }

    updateProfile() {
        this.profile.B = this.profileData.value.B;
        this.profile.H = this.profileData.value.H;
        this.profile.eo = this.profileData.value.eo;
        this.profile.es = this.profileData.value.es;
        this.profile.Wy = this.profileData.value.Wy;
        this.profile.Aef = this.profileData.value.Aef;
        this.profile.Ix = this.profileData.value.Ix;
        this.profile.Q = this.profileData.value.Q;
        this.profile.Lc = this.profileData.value.Lc;
        this.profile.Iy = this.profileData.value.Iy;
        this.profile.A = this.profileData.value.A;
        this.profile.ry = this.profileData.value.ry;
        this.profile.Mc = this.profileData.value.Mc;
        this.profile.Wx = this.profileData.value.Wx;
        this.profile.rx = this.profileData.value.rx;
    }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/frame-profile-form/frame-profile-form.component.ts